/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2LedgerFilterInvoices/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2LedgerFilterInvoices({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2LedgerFilterInvoices",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 13,
  height = 13,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  stroke = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2LedgerFilterInvoices.Svg"
  data-view-path={viewPath}
 viewBox="0 0 13 13"
 style={{'--as-1-8vnEf': alignSelf,'--mt-2-8vnEf': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-8vnEf': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-8vnEf': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-8vnEf': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-8vnEf': opacity,'--w-10-8vnEf': typeof width === 'number' ? `${width}px` : width,'--h-11-8vnEf': typeof height === 'number' ? `${height}px` : height,'--f-12-8vnEf': fill,'--a-7-8vnEf': isAnimated ? animation : "none",'--sd-8-8vnEf': isAnimated ? strokeDashoffset : 0,'--sd-9-8vnEf': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2LedgerFilterInvoices.SvgPath"
  data-view-path={viewPath}
 d="M2.346 3.731h-.923a.923.923 0 00-.923.923v6.923c0 .51.413.923.923.923h10.154c.51 0 .923-.413.923-.923V4.654a.923.923 0 00-.923-.923h-.923M3.269 9.73h3.23M6.5 6.038V.5M4.192 2.808L6.5.5l2.308 2.308"
 strokeLinecap="round"
 strokeLinejoin="round"
 style={{'--s-13-8vnEf': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="Tysiav2LedgerFilterInvoices.SvgPath:1"
  data-view-path={viewPath}
 d="M8.808 9.73a.923.923 0 101.846 0 .923.923 0 00-1.846 0z"
 strokeLinecap="round"
 strokeLinejoin="round"
 style={{'--s-13-8vnEf': stroke}}
 className={`views-block ${styles.SvgPath1}`}
/>
</svg>
{children}
</React.Fragment>)
}